module.exports = __webpack_public_path__ + "static/ses-2021-ar21-bookmark-137f6507d92894090876b1c04ee0f0ea.pdf";